import type { ModalProps } from '@vista-digital/occ-ui'
import { navigationService } from '../../../services/navigation.service'
import type GlobalPopup from '../models'
import getPropsElements from '../SubComponents/getPropsElements'

export const getPopupProps = (
    enabledPopup: GlobalPopup | undefined,
    closePopup: () => void,
    show: boolean
): ModalProps | undefined => {
    if (!enabledPopup) return undefined

    const onButtonClick = () => {
        const url = enabledPopup?.button?.url
        const isTarget = enabledPopup?.button?.target === '_blank'

        closePopup()

        if (!url || url === '#') {
            return
        }
        navigationService.goTo(url, isTarget)
    }

    return {
        show,
        className: 'global-popup',
        onClose: closePopup,
        ...getPropsElements(onButtonClick, enabledPopup),
    }
}

export default getPopupProps
